const cliente = {
  getClientesPorAcademia: 'listado-clientes',
  exportClientesPorAcademia: 'listado-clientes/export'
}

export default cliente
